import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import TitleWrapper from "../../../components/ui/titlewrapper/TitleWrapper";
import AccordionWrapper from "../../../components/ui/accordion/AccordionWrapper";
import { FileFormats } from "../../../components/forms/libs/data/fileFormatTypes";
import { ImageFormats } from "../../../components/forms/libs/data/imageFormatTypes";
// import { GeneratePDFForIndividualMember } from "../GeneratePDFForIndividualMember";

const initState = {
  salutationId: "",
  firstName: "",
  lastName: "",
  displayName: "",
  DisplayPhoto: null,
  gender: "Male",
  dateofBirth: null,
  placeofBirth: "",
  nationalityId: null,
  last4DigitsofNRIC: "",
  workpass: "",
  mailingAddressLine1: "",
  mailingAddressLine2: "",
  mailingAddressLine3: "",
  countryId: null,
  postalCode: "",
  emailAddress: "",
  mobile: "",
  highestQualificationId: null,
  highestQualificationOthers: "",
  academicDegree: "",
  awardingBody: "",
  otherQualifications: "",
  currentlyEmployed: null,
  organisationCompany: "",
  jobTitle: "",
  jobRoleId: null,
  bio: "",
  organisationAddressLine1: "",
  organisationAddressLine2: "",
  organisationAddressLine3: "",
  empCountryId: null,
  empPostalCode: "",
  empEmailAddress: "",
  empMobile: "",
  linkdein: "",
  isPublicAccountantRegACRA: false,
  isCharteredAccountant: false,
  isAdvocateAndSolicater: false,
  isOtherProfessional: false,
  professionalInformationOther: "",
  iscriminaloffence: 'no',
  criminaloffenceMoreDetails: "",
  isBenifitsOfYourCreditors: 'no',
  benifitsOfYourCreditorsMoreDetails: "",
  resumeWorkExpFile: null,
  relevantDiplomasCertificatesFile: null,
  detailedListAppRoleRespoFile: null,
  yearsOfRIExp: "",
  firstCharacterRefFile: null,
  secondCharacterRefFile: null,
  // isSubscribeToMailList: false,
};

export const CreateHonoraryMemberData = {
  name: "Create Honorary Member Form",
  initialState: initState,
  section: [
    {
      title: "Applicant Information",
      row: {},
      style: {
        sectionStyle: "vertical-form mb-3 form-card row",
      },

      wrapperTemplate: (
        <AccordionWrapper title="Applicant Information" id="1" />
      ),

      fields: [
        {
          id: "salutationId",
          label: "First Name as in NRIC/Passport",
          Field_Name: "Salutation",
          fieldType: FormFieldTypes.SELECT,
          dataField: "salutationId",
          fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            options: [],
          },

          style: {
            containerCss: "col-xl-8 col-lg-8 col-md-8 mb-2 salutation-selec",
          },
        },
        {
          id: "firstName",
          label: "",
          Field_Name: "First Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "firstName",
          fieldSetting: {
            placeholder: "",
            allowSpace: true,
          },

          style: {
            containerCss: "col-xl-4 col-lg-4 col-md-4 input-top-title-custom",
          },
        },
        // {
        //   id: "firstName",
        //   label: "First Name as in NRIC/Passport",
        //   Field_Name: "First Name as in NRIC/Passport",
        //   fieldType: FormFieldTypes.INPUT,
        //   dataField: "firstName",
        //   fieldSetting: {
        //     placeholder: "Please Enter First Name",
        //     allowSpace: true,
        //     textareaRows: 4,
        //   },

        //   style: {
        //     containerCss: "col-lg-12 col-md-12 validation-left-0 ",
        //   },
        // },
        {
          id: "lastName",
          label: "Last Name as in NRIC/Passport ",
          Field_Name: "Last Name as in NRIC/Passport",
          fieldType: FormFieldTypes.INPUT,
          dataField: "lastName",
          fieldSetting: {
            placeholder: "Please Enter Last Name",
            allowSpace: true,
            textareaRows: 4,
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "displayName",
          label: "Display Name",
          Field_Name: "Dispaly Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "displayName",
          fieldSetting: {
            placeholder: "Please Enter Display Name",
            allowSpace: true,
            textareaRows: 4,
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        // {
        //   id: "DisplayPhoto",
        //   Field_Name: "Display Photo",
        //   label: "Display Photo",
        //   fieldType: FormFieldTypes.IMAGE,
        //   dataField: "DisplayPhoto",
        //   fieldSetting: {
        //     placeholder: "Display Photo",
        //     allowMultipleImage: false,
        //     acceptedImageFormats: [
        //       ImageFormats.JPEG,
        //       ImageFormats.BMP,
        //       ImageFormats.JPG,
        //       ImageFormats.PNG,
        //       ImageFormats.WEBP,
        //     ],
        //     isDownloadable: true,
        //     maxImageHeight: 1280, // Minimum Image Height in Pixels
        //     maxImageWidth: 1920, // Maximum Image Width in Pixels
        //     // minImageHeight: 225, // Minimum Image Height in Pixels
        //     // minImageWidth: 225, // maximum Image Width in Pixels
        //     minImageSizeInMB: 0, // Minimum Image size in MB
        //     maxImageSizeInMB: 2, // Maximum Image size in MB
        //   },
        //   style: {
        //     containerCss: "col-lg-12 col-md-12 profile-pic-upload validation-text-fileuploader",
        //   },
        // },
        {
          id: "DisplayPhoto",
          Field_Name: "Display Photo",
          label: "Display Photo",
          fieldType: FormFieldTypes.IMAGECROPPER,
          dataField: "DisplayPhoto",
          fieldSetting: {

            allowMultipleImage: false,
            acceptedImageFormats: [
              ImageFormats.JPEG,
              ImageFormats.JPG,
              ImageFormats.PNG,
            ],
            isDownloadable: true,
            isPreview: true,
            minImageSizeInMB: 0, // Minimum Image size in MB
            maxImageSizeInMB: 2, // Maximum Image size in MB
            aspectRatio: 400 / 400,
            height: 400,
            width: 400,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "gender",
          label: "Gender",
          Field_Name: "Gender",
          fieldType: FormFieldTypes.RADIOBUTTON,
          dataField: "gender",
          fieldSetting: {
            allowSpace: true,
            options: [
              { value: "male", label: "Male" },
              { value: "female", label: "Female" },
            ],
          },

          style: {
            containerCss: "col-lg-12 radioStyle col-md-12 ",
          },
        },
        {
          id: "dateofBirth",
          label: "Date of Birth",
          Field_Name: "Date of Birth",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "dateofBirth",
          fieldSetting: {
            allowSpace: true,
            placeholder: "Select",
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0",
          },
        },
        {
          id: "placeofBirth",
          label: "Place of Birth ",
          Field_Name: "Place of Birth",
          fieldType: FormFieldTypes.SELECT,
          dataField: "placeofBirth",
          fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            options: [],
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0",
          },
        },
        {
          id: "nationalityId",
          label: "Nationality",
          Field_Name: "Nationality",
          fieldType: FormFieldTypes.SELECT,
          dataField: "nationalityId",
          fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            options: [],
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0",
          },
        },
        {
          id: "last4DigitsofNRIC",
          label: "NRIC / Passport No",
          Field_Name: "NRIC / Passport No",
          fieldType: FormFieldTypes.INPUT,
          dataField: "last4DigitsofNRIC",
          fieldSetting: {
            placeholder: "Please Enter NRIC / Passport No",
            allowSpace: true,
            textareaRows: 4,
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "workpass",
          label: "Workpass",
          Field_Name: "Workpass",
          fieldType: FormFieldTypes.INPUT,
          dataField: "workpass",
          fieldSetting: {
            placeholder: "Please Enter workpass",
            allowSpace: true,
            textareaRows: 4,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "mailingAddressLine1",
          label: "Mailing Address Line 1",
          Field_Name: "Mailing Address Line 1",
          fieldType: FormFieldTypes.INPUT,
          dataField: "mailingAddressLine1",
          fieldSetting: {
            placeholder: "Please Enter Mailing Address Line 1",
            allowSpace: true,
            textareaRows: 4,
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "mailingAddressLine2",
          label: "Mailing Address Line 2",
          Field_Name: "Mailing Address Line 2",
          fieldType: FormFieldTypes.INPUT,
          dataField: "mailingAddressLine2",
          fieldSetting: {
            placeholder: "Please Enter Mailing Address Line 2",
            allowSpace: true,
            textareaRows: 4,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "mailingAddressLine3",
          label: "Mailing Address Line 3",
          Field_Name: "Mailing Address Line 3",
          fieldType: FormFieldTypes.INPUT,
          dataField: "mailingAddressLine3",
          fieldSetting: {
            placeholder: "Please Enter Mailing Address Line 3",
            allowSpace: true,
            textareaRows: 4,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "countryId",
          label: "Country",
          Field_Name: "Country",
          fieldType: FormFieldTypes.SELECT,
          dataField: "countryId",
          fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            options: [],
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0",
          },
        },
        {
          id: "postalCode",
          label: "Postal Code",
          Field_Name: "Postal Code",
          fieldType: FormFieldTypes.NUMERIC,
          dataField: "postalCode",
          fieldSetting: {
            placeholder: "123-456",
            masking: {
              isMasking: true,
              showMask: true,
              maskFormat: "___-___",
              maskPlaceholder: "",
              maskReplacement: { _: /\d/ },
            },
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0",
          },
        },
        {
          id: "emailAddress",
          label: "Email Address",
          Field_Name: "Email Address",
          fieldType: FormFieldTypes.INPUT,
          dataField: "emailAddress",
          fieldSetting: {
            placeholder: "Please Enter Email Address",
            allowSpace: true,
            textareaRows: 4,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },

        {
          id: "mobile",
          label: "Mobile",
          Field_Name: "Mobile",
          fieldType: FormFieldTypes.PHONE,
          dataField: "mobile",
          fieldSetting: {
            placeholder: "",
            defaultCountry: "Sg",
            allowSpace: true,

          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
      ],
    },
    {
      title: "Education Information",
      row: {},
      style: {
        sectionStyle: "vertical-form mb-3 form-card row",
      },

      wrapperTemplate: (
        <AccordionWrapper title="Education Information" id="2" />
      ),

      fields: [
        {
          id: "highestQualificationId",
          label: "Highest Qualification Attained (Academic Degree)",
          Field_Name: "Highest Qualification Attained (Academic Degree)",
          fieldType: FormFieldTypes.SELECT,
          dataField: "highestQualificationId",
          fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            options: [],
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0",
          },
        },
        {
          id: "academicDegree",
          label: "Academic Degree, Professional Examination or Equivalent",
          Field_Name: "Comments",
          fieldType: FormFieldTypes.INPUT,
          dataField: "academicDegree",
          fieldSetting: {
            placeholder:
              "Please Enter Academic Degree, Professional Examination or Equivalent",
            allowSpace: true,
            textareaRows: 4,
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "awardingBody",
          label: "Awarding Body / Institution / University",
          Field_Name: "Awarding Body / Institution / University",
          fieldType: FormFieldTypes.INPUT,
          dataField: "awardingBody",
          fieldSetting: {
            placeholder:
              "Please Enter Awarding Body / Institution / University",
            allowSpace: true,
            textareaRows: 4,
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },

        {
          id: "otherQualifications",
          label: "Other Qualifications",
          Field_Name: "Other Qualifications",
          fieldType: FormFieldTypes.INPUT,
          dataField: "otherQualifications",
          fieldSetting: {
            placeholder: "Please Enter Other Qualifications",
            allowSpace: true,
            textareaRows: 4,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
      ],
    },
    {
      title: "Employment Information",
      row: {},
      style: {
        sectionStyle: "vertical-form mb-3 form-card row",
      },

      wrapperTemplate: (
        <AccordionWrapper title="Employment Information" id="3" />
      ),

      fields: [
        {
          id: "currentlyEmployed",
          label: "Currently Employed",
          Field_Name: "Currently Employed",
          fieldType: FormFieldTypes.RADIOBUTTON,
          dataField: "currentlyEmployed",
          fieldSetting: {
            allowSpace: true,
            options: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
          },

          style: {
            containerCss: "col-lg-12 radioStyle col-md-12 ",
          },
        },
        {
          id: "organisationCompany",
          label: "Organisation / Company",
          Field_Name: "Organisation / Company",
          fieldType: FormFieldTypes.INPUT,
          dataField: "organisationCompany",
          fieldSetting: {
            placeholder: "Please Enter Organisation / Company",
            allowSpace: true,
            textareaRows: 4,
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "jobTitle",
          label: "Job Title",
          Field_Name: "Job Title",
          fieldType: FormFieldTypes.INPUT,
          dataField: "jobTitle",
          fieldSetting: {
            placeholder: "Please Enter JobTitle",
            allowSpace: true,
            textareaRows: 4,
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "jobRoleId",
          label: "Job Role",
          Field_Name: "Job Role",
          fieldType: FormFieldTypes.SELECT,
          dataField: "jobRoleId",
          fieldSetting: {
            placeholder: "Please Enter Job Role",
            allowSpace: true,
            textareaRows: 4,
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "bio",
          label: "Bio (max 400 words)",
          Field_Name: "Bio",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "bio",
          fieldSetting: {
            placeholder: "Please Enter Bio",
            allowSpace: true,
            textareaRows: 4,
            maxWords: 400,
            showWordCount: true
          },

          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "organisationAddressLine1",
          label: "Organisation Address Line 1",
          Field_Name: "Organisation Address Line 1",
          fieldType: FormFieldTypes.INPUT,
          dataField: "organisationAddressLine1",
          fieldSetting: {
            placeholder: "Please Enter Organisation Address Line 1",
            allowSpace: true,
            textareaRows: 4,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "organisationAddressLine2",
          label: "Organisation Address Line 2",
          Field_Name: "Organisation Address Line 2",
          fieldType: FormFieldTypes.INPUT,
          dataField: "organisationAddressLine2",
          fieldSetting: {
            placeholder: "Please Enter Organisation Address Line 2",
            allowSpace: true,
            textareaRows: 4,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "organisationAddressLine3",
          label: "Organisation Address Line 3",
          Field_Name: "Organisation Address Line 3",
          fieldType: FormFieldTypes.INPUT,
          dataField: "organisationAddressLine3",
          fieldSetting: {
            placeholder: "Please Enter Organisation Address Line 3",
            allowSpace: true,
            textareaRows: 4,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "empCountryId",
          label: "Country",
          Field_Name: "Country",
          fieldType: FormFieldTypes.SELECT,
          dataField: "empCountryId",
          fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            options: [],
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0",
          },
        },
        {
          id: "empPostalCode",
          label: "Postal Code",
          Field_Name: "Postal Code",
          fieldType: FormFieldTypes.MASKINPUT,
          dataField: "empPostalCode",
          fieldSetting: {
            placeholder: "123-456",
            masking: {
              isMasking: true,
              showMask: true,
              maskFormat: "___-___",
              maskPlaceholder: "",
              maskReplacement: { _: /\d/ },
            },
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0",
          },
        },
        {
          id: "empEmailAddress",
          label: "Email Address (if different from above)",
          Field_Name: "Email Address (if different from above)",
          fieldType: FormFieldTypes.INPUT,
          dataField: "empEmailAddress",
          fieldSetting: {
            placeholder: "Please Enter Email Address",
            allowSpace: true,
            textareaRows: 4,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "empMobile",
          label: "Mobile (if different from above)",
          Field_Name: "Mobile (if different from above)",
          fieldType: FormFieldTypes.PHONE,
          dataField: "empMobile",
          fieldSetting: {
            placeholder: "Please Enter Mobile Number",
            defaultCountry: 'sg',
            allowSpace: true,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
        {
          id: "linkdein",
          label: "Linkedin",
          Field_Name: "Linkedin",
          fieldType: FormFieldTypes.INPUT,
          dataField: "linkdein",
          fieldSetting: {
            placeholder: "Please Enter Linkedin",
            allowSpace: true,
            textareaRows: 4,
          },
          style: {
            containerCss: "col-lg-12 col-md-12 validation-left-0 ",
          },
        },
      ],
    },
    {
      title: "Professional Information",
      row: {},
      style: {
        sectionStyle: "vertical-form mb-3 form-card row",
      },

      wrapperTemplate: (
        <AccordionWrapper title="Professional Information" id="4" />
      ),

      fields: [
        {
          id: "professionalInformationTitle",
          label: "",
          formTitle: "",
          fieldType: FormFieldTypes.MAINFORMTITLE,
          fieldSetting: {
            formTitle: "Professional Information",
          },
          style: {
            containerCss: "col-lg-12 col-md-12 ",
          },
        },
        {
          id: "isPublicAccountantRegACRA",
          label: "Please indicate all that apply in the appropriate box",
          Field_Name: "Public Accountant registered with ACRA",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isPublicAccountantRegACRA",
          fieldSetting: {
            options: [],
          },
          style: {
            containerCss: "col-lg-6 col-md-6 radioStyle  mb-2 label-input ",
          },
        },
        {
          id: "isPublicAccountantRegACRA",
          label: "Public Accountant registered with ACRA",
          Field_Name: "Public Accountant registered with ACRA",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isPublicAccountantRegACRA",
          fieldSetting: {
            options: [],
          },
          style: {
            containerCss: "col-lg-6 col-md-6 radioStyle  mb-2 normal-checkbox",
          },
        },
        {
          id: "isPublicAccountantRegACRA",
          label: "",
          Field_Name: "",
          fieldType: FormFieldTypes.MAINFORMTITLE,
          dataField: "isPublicAccountantRegACRA",
          fieldSetting: {
            options: [],
          },
          style: {
            containerCss: "col-lg-6 col-md-6 radioStyle label-input-blank",
          },
        },
        {
          id: "isCharteredAccountant",
          label: "Chartered Accountant",
          Field_Name: "Chartered Accountant",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isCharteredAccountant",
          fieldSetting: {
            options: [],
          },
          style: {
            containerCss:
              "col-lg-6 col-md-6 ml-auto radioStyle  mb-2 normal-checkbox",
          },
        },
        {
          id: "isPublicAccountantRegACRA",
          label: "",
          Field_Name: "",
          fieldType: FormFieldTypes.MAINFORMTITLE,
          dataField: "isPublicAccountantRegACRA",
          fieldSetting: {
            options: [],
          },
          style: {
            containerCss: "col-lg-6 col-md-6 radioStyle label-input-blank",
          },
        },
        {
          id: "isAdvocateAndSolicater",
          label: "Advocate and Solicater of the Supreme Court",
          Field_Name: "Advocate and Solicater of the Supreme Court",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isAdvocateAndSolicater",
          fieldSetting: {
            options: [],
          },
          style: {
            containerCss:
              "col-lg-6 col-md-6 ml-auto radioStyle  mb-2 normal-checkbox",
          },
        },
        {
          id: "isPublicAccountantRegACRA",
          label: "",
          Field_Name: "",
          fieldType: FormFieldTypes.MAINFORMTITLE,
          dataField: "isPublicAccountantRegACRA",
          fieldSetting: {
            options: [],
          },
          style: {
            containerCss: "col-lg-6 col-md-6 radioStyle label-input-blank",
          },
        },
        {
          id: "isOtherProfessional",
          label: "Others",
          Field_Name: "Others",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isOtherProfessional",
          fieldSetting: {
            options: [],
          },
          style: {
            containerCss:
              "col-lg-6 col-md-6 ml-auto radioStyle  mb-2 normal-checkbox",
          },
        },
      ],
    },
    {
      title: "Other Information",
      row: {},
      style: {
        sectionStyle: "vertical-form mb-3 form-card row",
      },

      wrapperTemplate: <AccordionWrapper title="Other Information" id="5" />,

      fields: [
        {
          id: "iscriminaloffence",
          label: "Have you ever been convicted of any criminal offence?",
          Field_Name: "Have you ever been convicted of any criminal offence?",
          fieldType: FormFieldTypes.RADIOBUTTON,
          dataField: "iscriminaloffence",
          fieldSetting: {
            allowSpace: true,
            options: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
          },

          style: {
            containerCss: "col-lg-12 radioStyle col-md-12 ",
          },
        },

        {
          id: "isBenifitsOfYourCreditors",
          label:
            "Have you ever been adjudged a bankrupt or made an assignment for the benefit of your creditors? ",
          Field_Name:
            "Have you ever been adjudged a bankrupt or made an assignment for the benefit of your creditors? ",
          fieldType: FormFieldTypes.RADIOBUTTON,
          dataField: "isBenifitsOfYourCreditors",
          fieldSetting: {
            allowSpace: true,
            options: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
          },

          style: {
            containerCss: "col-lg-12 radioStyle col-md-12 ",
          },
        },
      ],
    },
    {
      title: "Support Documents",
      row: {},
      style: {
        sectionStyle: "vertical-form mb-3 form-card row",
      },

      wrapperTemplate: <AccordionWrapper title="Support Documents" id="6" />,

      fields: [
        {
          id: "resumeWorkExpFile",
          label: "A resume outlining your work experience, position and company worked for, including a description of your main job responsibilities, and highlighting restructuring and insolvency (R&I) related experiences where applicable.",
          Field_Name: "resume outlining your work experience",
          fieldType: FormFieldTypes.FILE,
          dataField: "resumeWorkExpFile",
          fieldSetting: {
            // placeholder: "Data File",
            allowMultipleFiles: false,
            acceptedFileFormats: [
              FileFormats.PDF,
              FileFormats.DOC,
              FileFormats.DOCX,
              FileFormats.XLSX,
            ],
            minFileSizeInMB: 0, // Minimum File size in MB
            maxFileSizeInMB: 2, // Maximum File size in MB
          },

          style: {
            containerCss: "col-lg-12 radioStyle col-md-12 ",
          },
        },
        {
          id: "relevantDiplomasCertificatesFile",
          label: "Relevant Diplomas/Certificates",
          Field_Name: "Relevant Diplomas/Certificates",
          fieldType: FormFieldTypes.FILE,
          dataField: "relevantDiplomasCertificatesFile",
          fieldSetting: {
            // placeholder: "Data File",
            allowMultipleFiles: false,
            acceptedFileFormats: [
              FileFormats.PDF,
              FileFormats.DOC,
              FileFormats.DOCX,
              FileFormats.XLSX,
            ],
            minFileSizeInMB: 0, // Minimum File size in MB
            maxFileSizeInMB: 2, // Maximum File size in MB
          },

          style: {
            containerCss: "col-lg-12 radioStyle col-md-12 ",
          },
        },
        {
          id: "detailedListAppRoleRespoFile",
          label: "A detailed list specifying the Applicant's role/responsibilities in R&I matters for at least the last seven years.",
          Field_Name: "A detailed list specifying the Applicant's role/responsibilities in R&I matters for at least the last seven years.",
          fieldType: FormFieldTypes.FILE,
          dataField: "detailedListAppRoleRespoFile",
          fieldSetting: {
            isHideDeleteButton: true,
            allowMultipleFiles: false,
            acceptedFileFormats: [
              FileFormats.PDF,
              FileFormats.DOC,
              FileFormats.DOCX,
              FileFormats.XLSX,
            ],
            minFileSizeInMB: 0, // Minimum File size in MB
            maxFileSizeInMB: 2, // Maximum File size in MB
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss:
              "col-lg-12 radioStyle col-md-12",
          },
        },
        {
          id: "yearsOfRIExp",
          label: "Years of R& I experience (at least 7 years of approved practical experience)",
          Field_Name: "Years of R& I experience (at least 7 years of approved practical experience)",
          fieldType: FormFieldTypes.INPUT,
          dataField: "yearsOfRIExp",
          fieldSetting: {
            placeholder: "",
            allowSpace: true,
          },

          style: {
            containerCss: "col-lg-12 col-md-12 ",
          },
        },
      ],
    },
    {
      title: "Character Reference",
      row: {},
      style: {
        sectionStyle: "vertical-form mb-3 form-card row",
      },

      wrapperTemplate: <AccordionWrapper title="Character Reference" id="7" />,

      fields: [
        {
          id: "firstCharacterRefFile",
          label: (
            <>
              First Character Reference (
              <a
                href="/Character Reference Form (Fillable).pdf"
                download="Character_Reference_Form.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download File
              </a>
              )
              {/* <span className="validation-star">*</span> */}
            </>
          ),
          Field_Name:
            "Download File and Upload Capablity First Character Reference",
          fieldType: FormFieldTypes.FILE,
          dataField: "firstCharacterRefFile",
          fieldSetting: {
            // placeholder: "Data File",
            allowMultipleFiles: false,
            acceptedFileFormats: [
              FileFormats.PDF,
              FileFormats.DOC,
              FileFormats.DOCX,
              FileFormats.XLSX,
            ],
            minFileSizeInMB: 0, // Minimum File size in MB
            maxFileSizeInMB: 2, // Maximum File size in MB
          },

          style: {
            containerCss: "col-lg-12 radioStyle col-md-12 ",
          },
        },
        {
          id: "secondCharacterRefFile",
          label: (
            <>
              Second Character Reference (
              <a
                href="/Character Reference Form (Fillable).pdf"
                download="Character_Reference_Form.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download File
              </a>
              )
              {/* <span className="validation-star">*</span> */}
            </>
          ),
          Field_Name:
            "Download File and Upload Capablity Second Character Reference",
          fieldType: FormFieldTypes.FILE,
          dataField: "secondCharacterRefFile",
          fieldSetting: {
            // placeholder: "Data File",
            allowMultipleFiles: false,
            acceptedFileFormats: [
              FileFormats.PDF,
              FileFormats.DOC,
              FileFormats.DOCX,
              FileFormats.XLSX,
            ],
            minFileSizeInMB: 0, // Minimum File size in MB
            maxFileSizeInMB: 2, // Maximum File size in MB
          },

          style: {
            containerCss: "col-lg-12 radioStyle col-md-12 ",
          },
        },
      ],
    },
    // {
    //   title: "Communication",
    //   row: {},
    //   style: {
    //     sectionStyle: "vertical-form mb-3 form-card row",
    //   },

    //   wrapperTemplate: <TitleWrapper title="Communication" />,

    //   fields: [
    //     {
    //       id: "isSubscribeToMailList",
    //       label: "I would like to subscribe to mailing list",
    //       Field_Name: "I would like to subscribe to mailing list",
    //       fieldType: FormFieldTypes.CHECKBOX,
    //       dataField: "isSubscribeToMailList",
    //       fieldSetting: {
    //         options: [],
    //       },
    //       style: {
    //         containerCss:
    //           "col-lg-12 col-md-12 radioStyle  mb-2 normal-checkbox",
    //       },
    //     },
    //   ],
    // },
  ],
};
